import { ThunkAction } from 'redux-thunk';
import { api2 } from '../apis';
import { GOVT_FORM_SUBMITTED, GOVT_FORM_SUBMITTING, GOVT_FORM_FAILED, GOVT_FORM_RESET, GOVT_UPLOAD_FORM } from 'store/types/govtDocument.type';
import { State } from 'store/reducers/auth.reducer';
import { commonError, commonLoading, commonSuccess } from './common.action';
import { useEffect } from 'react';

const formSubmitting = () => ({ type: GOVT_FORM_SUBMITTING });
const formSubmitted = (success: string) => ({ type: GOVT_FORM_SUBMITTED, success });
const formFailed = (error: string) => ({ type: GOVT_FORM_FAILED, error });
export const govtFormReset = () => ({ type: GOVT_FORM_RESET })
export const govtFormResetUpload = () => ({ type: GOVT_UPLOAD_FORM })

export type Actions =
  | ReturnType<typeof formSubmitting>
  | ReturnType<typeof formSubmitted>
  | ReturnType<typeof formFailed>
  | ReturnType<typeof govtFormReset>
  | ReturnType<typeof govtFormResetUpload>;

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export const sendGovtRecordRequest = (data: any, callback?: () => any): ThunkResult<void> => dispatch => {
  dispatch(formSubmitting());
  return api2
    .post('/api/v2/authorizations/upload_government_document', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })(dispatch, false, true)
    .then(res => {
      dispatch(formSubmitted(res.message))
      callback && callback()
    })
    .catch(err => dispatch(formFailed(err.message)))
};

export const sendPatientFormRequest = (data: any, callback?: () => any): ThunkResult<void> => dispatch => {
  dispatch(formSubmitting());
  return api2
    .post('/api/v2/authorizations/upload_patient_form', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })(dispatch, false, true)
    .then(res => {
      dispatch(formSubmitted(res.message))
      callback && callback()
    })
    .catch(err => dispatch(formFailed(err.message)))
};


export const deleteGovtId = (id: number): ThunkResult<void> => async dispatch => {
  api2
    .delete('/api/v2/request/record_request/remove_government_document', { id })(dispatch)
    .then(res => console.log('Deleted'))
    .catch(error => console.log('ERRR', error));
};



export const checkUploadDocument = (user_id: any): ThunkResult<void> => dispatch => {
  return api2.get('/api/v2/provider_signup_account_activation/check_govt_document?user_id='+useEffect, {
    method: 'get'
  })(dispatch, false, true)
  .then(res => {
    // dispatch(govtFormResetUpload())
  })
};
